import easydropdown from 'easydropdown'

export const settings = {
  selector: '.language-navigation',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const dropdown = element.querySelector( 'select' )
  initLangDropdown( dropdown )
}

/**
 *
 * @param {DOMNode} dropdownEl
 */
const initLangDropdown = ( dropdownEl ) => {
  easydropdown( dropdownEl, {
    callbacks: {
      onSelect: ( value ) => window.location.href = value
    }
  })
}
